import type { DisplayMode } from '@/types/book';

/**
 * 将书本内部页索引格式化为用户可见的页码文案。
 * 双页模式跨页显示 "1 - 2"，封面/封底单页显示 "1"。
 */
export function formatBookPageLabel(
  currentPageIndex: number,
  totalPages: number,
  displayMode: DisplayMode = 'double'
): string {
  if (totalPages <= 0) return '0';

  if (displayMode === 'single') {
    return String(Math.min(Math.max(currentPageIndex, 0) + 1, totalPages));
  }

  const leftIndex = currentPageIndex;
  const leftExists = leftIndex >= 0 && leftIndex < totalPages;
  const rightExists = leftIndex + 1 >= 0 && leftIndex + 1 < totalPages;
  const toDisplayPage = (index: number) => index + 1;

  // 步骤 1：双页跨页，显示起止页码
  if (leftExists && rightExists) {
    return `${toDisplayPage(leftIndex)} - ${toDisplayPage(leftIndex + 1)}`;
  }

  // 步骤 2：封面仅右页可见
  if (!leftExists && rightExists) {
    return String(toDisplayPage(leftIndex + 1));
  }

  // 步骤 3：封底仅左页可见
  if (leftExists && !rightExists) {
    return String(toDisplayPage(leftIndex));
  }

  return '0';
}
